import React from 'react';
import TabBar from '../common/tabs/TabBar';
import DropDown from '../common/DropDown';
import Grid from 'styled-components-grid';
import types from './types';
import extractSetting from './extractSetting';

const SettingsTabBar = ({settings, toggleSettings, type: activeType}) => {
  return (
    <TabBar dark>
      {types.map(({type, label}) => (
        <Grid.Unit key={type} size={1 / 3} onClick={() => toggleSettings(type)}>
          <DropDown label={label} value={extractSetting(settings, type)} active={type === activeType} />
        </Grid.Unit>
      ))}
    </TabBar>
  );
};

export default SettingsTabBar;
